function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "pal7uml56a",
  colorInterpolationFilters: "auto"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#pal7uml56a)",
  transform: "translate(-280.000000, -312.000000) translate(0.000000, 216.000000) translate(0.000000, 80.000000)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#0283FB",
  transform: "translate(280.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.998 3.892C8.82 5.13 10.5 7.802 10.5 9c0 .69-.28 1.315-.732 1.768-.453.452-1.078.732-1.768.732s-1.315-.28-1.768-.732C5.78 10.315 5.5 9.69 5.5 9c0-1.21 1.695-3.9 2.498-5.108z"
}))))));
const SvgUiIconUtility16WaterCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUiIconUtility16WaterCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ui-icon-utility-16-water-circle.9047e2be.svg";
export { ForwardRef as ReactComponent };